import { render, staticRenderFns } from "./FloorWrap.vue?vue&type=template&id=31b9c1ea&scoped=true&"
import script from "./FloorWrap.vue?vue&type=script&lang=js&"
export * from "./FloorWrap.vue?vue&type=script&lang=js&"
import style0 from "./FloorWrap.vue?vue&type=style&index=0&id=31b9c1ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9c1ea",
  null
  
)

export default component.exports